import { render, staticRenderFns } from "./GenerateCertificate.vue?vue&type=template&id=ef0400b8&scoped=true&"
import script from "./GenerateCertificate.vue?vue&type=script&lang=js&"
export * from "./GenerateCertificate.vue?vue&type=script&lang=js&"
import style0 from "./GenerateCertificate.vue?vue&type=style&index=0&id=ef0400b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0400b8",
  null
  
)

export default component.exports